import { useState, useEffect } from "react";
import { Snackbar, Alert, Link, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export default function PrivacyNotice() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const dismissed = localStorage.getItem("privacyNoticeDismissed") === "true";
        if (!dismissed) setOpen(true);
    }, []);

    const handleClose = () => {
        localStorage.setItem("privacyNoticeDismissed", "true");
        setOpen(false);
    };

    const handleReadPolicy = () => {
        handleClose();
        navigate("/privacy-policy");
    };

    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            sx={{ m: 2, zIndex: 1500 }}
            autoHideDuration={null}
        >
            <Alert
                severity="info"
                variant="filled"
                icon={false}
                color="info"
                sx={{
                    width: "100%",
                    fontSize: "0.875rem",
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    "& .MuiAlert-message": { flex: 1, py: 1 },
                }}
                action={
                    <IconButton
                        aria-label="закрыть"
                        size="small"
                        onClick={handleClose}
                        sx={{
                            color: "inherit",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography variant="body2">
                        Мы не собираем персональные данные и не используем cookies.
                    </Typography>
                    <Link
                        component="button"
                        onClick={handleReadPolicy}
                        sx={{
                            color: "inherit",
                            textDecoration: "underline",
                            fontWeight: 700,
                            p: 0,
                            cursor: "pointer",
                            "&:hover": { opacity: 0.9 },
                            alignSelf: "flex-start",
                        }}
                    >
                        Политика конфиденциальности
                    </Link>
                </Box>
            </Alert>
        </Snackbar>
    );
}
